import { Chart } from 'react-chartjs-2';
import { chartjs } from '../helpers';

export const bootstrapChartjs = () => {
    Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
        draw: chartjs.draw
    });
};
